import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 21px;
  height: 22px;
  color: #4f6e91;
`

const Csv = ({ title = 'Code Tag', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 21 22" title={title} {...rest}>
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="surveys-audience-3e-with-file" transform="translate(-820.000000, -538.000000)">
        <g id="surveys-audience1">
          <g id="Audience" transform="translate(327.000000, 314.000000)">
            <g id="audience-list" transform="translate(484.000000, 51.000000)">
              <g id="table-contents-copy" transform="translate(0.000000, 30.000000)">
                <g id="csv" transform="translate(10.000000, 144.000000)">
                  <path
                    d="M7.3,12.4 C7.06666667,12.4 6.86666667,12.5 6.73333333,12.6666667 C6.6,12.8333333 6.53333333,13.1 6.53333333,13.4333333 C6.53333333,14.1333333 6.8,14.4666667 7.3,14.4666667 C7.53333333,14.4666667 7.76666667,14.4 8.1,14.3 L8.1,14.8666667 C7.83333333,14.9666667 7.56666667,15.0333333 7.23333333,15.0333333 C6.76666667,15.0333333 6.43333333,14.9 6.2,14.6333333 C5.96666667,14.3666667 5.83333333,13.9666667 5.83333333,13.4666667 C5.83333333,13.1333333 5.9,12.8666667 6,12.6333333 C6.1,12.4 6.3,12.2 6.5,12.0666667 C6.73333333,11.9333333 6.96666667,11.8666667 7.26666667,11.8666667 C7.56666667,11.8666667 7.86666667,11.9333333 8.16666667,12.1 L8,12.6 C7.9,12.5333333 7.76666667,12.5 7.66666667,12.4666667 C7.56666667,12.4333333 7.4,12.4 7.3,12.4 Z"
                    id="Shape"
                    fill="currentColor"
                    fillRule="nonzero"
                  />
                  <path
                    d="M10.6666667,14.1333333 C10.6666667,14.4 10.5666667,14.6333333 10.3666667,14.8 C10.1666667,14.9666667 9.9,15.0333333 9.53333333,15.0333333 C9.2,15.0333333 8.9,14.9666667 8.66666667,14.8333333 L8.66666667,14.2333333 C8.86666667,14.3333333 9.06666667,14.4 9.2,14.4333333 C9.33333333,14.4666667 9.46666667,14.5 9.6,14.5 C9.73333333,14.5 9.86666667,14.4666667 9.93333333,14.4333333 C10,14.3666667 10.0333333,14.3 10.0333333,14.2 C10.0333333,14.1333333 10,14.1 9.96666667,14.0333333 C9.93333333,13.9666667 9.86666667,13.9333333 9.83333333,13.9 C9.76666667,13.8666667 9.63333333,13.8 9.43333333,13.7 C9.23333333,13.6 9.1,13.5333333 9,13.4333333 C8.9,13.3333333 8.83333333,13.2666667 8.76666667,13.1333333 C8.7,13 8.66666667,12.9 8.66666667,12.7333333 C8.66666667,12.4666667 8.76666667,12.2333333 8.93333333,12.1 C9.13333333,11.9333333 9.36666667,11.8666667 9.7,11.8666667 C9.86666667,11.8666667 10,11.9 10.1666667,11.9333333 C10.3,11.9666667 10.4666667,12.0333333 10.6333333,12.1 L10.4333333,12.6 C10.2666667,12.5333333 10.1333333,12.5 10.0333333,12.4666667 C9.93333333,12.4333333 9.83333333,12.4333333 9.7,12.4333333 C9.56666667,12.4333333 9.46666667,12.4666667 9.4,12.5333333 C9.33333333,12.6 9.33333333,12.6333333 9.33333333,12.7333333 C9.33333333,12.8 9.33333333,12.8333333 9.36666667,12.9 C9.4,12.9666667 9.43333333,13 9.5,13.0333333 C9.56666667,13.0666667 9.7,13.1333333 9.9,13.2666667 C10.2,13.4 10.4,13.5333333 10.5,13.6666667 C10.6,13.8 10.6666667,13.9333333 10.6666667,14.1333333 Z"
                    id="Shape"
                    fill="currentColor"
                    fillRule="nonzero"
                  />
                  <path
                    d="M13.0666667,11.9 L13.7333333,11.9 L12.7,15 L12,15 L10.9666667,11.9 L11.6333333,11.9 L12.2,13.7333333 C12.2333333,13.8333333 12.2666667,13.9666667 12.3,14.1 C12.3333333,14.2333333 12.3666667,14.3333333 12.3666667,14.4 C12.3666667,14.2666667 12.4333333,14.0333333 12.5333333,13.7333333 L13.0666667,11.9 Z"
                    id="Shape"
                    fill="currentColor"
                    fillRule="nonzero"
                  />
                  <polyline
                    id="Shape"
                    stroke="currentColor"
                    points="12.3333333 0 12.3333333 5.33333333 17.6666667 5.33333333"
                  />
                  <polyline
                    id="Shape"
                    stroke="currentColor"
                    strokeLinecap="square"
                    points="17.6666667 10 17.6666667 5.33333333 12.3333333 0 1.66666667 0 1.66666667 10"
                  />
                  <polyline
                    id="Shape"
                    stroke="currentColor"
                    strokeLinecap="square"
                    points="1.66666667 17 1.66666667 20 17.6666667 20 17.6666667 17"
                  />
                  <path d="M19.3333333,10 L0,10" id="Shape" stroke="currentColor" />
                  <polyline
                    id="Shape"
                    stroke="currentColor"
                    points="1.66666667 8.33333333 0 10 0 17 19.3333333 17 19.3333333 10 17.6666667 8.33333333"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

Csv.displayName = 'Csv'
Csv.needsWork = true
export default Csv
